export default __webpack_public_path__ + "static/media/Manual-9.df3539d4.png";